import { Action, Dispatch } from "redux";
import { Actions } from "./models";
import { ENDPOINTS } from "../config";
import { IState, IAppParams, ISearch, ISearchEntityRequest, EntityType, IDataEntityResponse } from "../models";
import { fetchFilters } from "../data";
import * as constants from "./constants";
import { generateRequest, orchestrateBenchmarkResponse, isNullOrUndefined } from "../utils";
import { getFunds } from "./";

const BASE_PERFORMANCE_REQUEST: ISearchEntityRequest = {
	type: "CLSS",
	search: [],
	include: {
		statistics: {},
		timeseries: {}
	},
	start: 0,
	limit: 1
};

export function primeCompareCollection(appParams: IAppParams) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let state = getState();
		let { shareClass, benchmarks, fund } = state;
		let payload = [shareClass];

		// The below code adds the I ACC Class to all other classes performance module. M&G have removed it but you never know... :P
		// let [iAccShare] = fund.shareClasses.filter((item) => item.properties.shareclass_name.toLowerCase() === "sterling i acc" && item.clientCode !== shareClass.clientCode);
		// if (iAccShare && (appParams.clienttype === "pri" || appParams.clienttype === "cha")) {
		// 	payload.push(iAccShare);
		// }

		let benchmarkIdentifier = shareClass.properties.comparative_index_sec_id;
		let peerGroupIdentifier = shareClass.properties.peer_group_sec_id;

		let responseAction: Actions = {
			type: constants.UPDATE_COMPARE
		};

		if (benchmarkIdentifier !== "") {
			payload = payload.concat(benchmarks.filter(item => item.clientCode === benchmarkIdentifier));
		}

		if (peerGroupIdentifier !== "") {
			payload = payload.concat(benchmarks.filter(item => item.clientCode === peerGroupIdentifier));
		}

		responseAction.payload = payload;
		dispatch(responseAction);
	}
}

export function addToCompare(type: EntityType, options: ISearch) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let state = getState();
		let payload;
		let responseAction: Actions = {
			type: constants.UPDATE_COMPARE
		};

		let [identifier] = options.values;
		let [isAlreadySelected] = state.compare.filter(item => item.clientCode === identifier);

		if (isNullOrUndefined(isAlreadySelected)) {
			if (type === "CLSS") {
				let response: IDataEntityResponse;
				let requestOptions = {
					type: type,
					search: [{ ...options }]
				};
				let requestBaseAmended = { ...BASE_PERFORMANCE_REQUEST, ...requestOptions };
				let request = await fetch(ENDPOINTS.fund.searchEntity, generateRequest("POST", requestBaseAmended));

				if (request.ok) {
					response = await request.json();
				} else {
					response.error = new Error(request.statusText);
				}

				response = orchestrateBenchmarkResponse(response);
				payload = [...state.compare, ...response.values];
			} else {
				let [selectedItem] = state.benchmarks.filter(item => item.clientCode === identifier);
				payload = [...state.compare, selectedItem];
			}
		} else {
			payload = [...state.compare];
		}

		responseAction.payload = payload;
		dispatch(responseAction);
	};
}

export function removeFromCompare(identifier) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let state = getState();
		let responseAction: Actions = {
			type: constants.UPDATE_COMPARE,
			payload: state.compare.filter(item => item.clientCode !== identifier)
		};
		dispatch(responseAction);
	};
}


// WEBPACK FOOTER //
// ./src/client/actions/compare.ts